<template>
  <div class="d-flex justify-center flex-column align-center w-full gap-1">
    <div class="px-4 text-center">
      <h1 class="text-h4 font-weight-black">
        {{ $t('settings.upgrade-warning.body-texts.0') }}
      </h1>
      <p class="mt-1 mb-2 text-subtitle-2">
        {{ $t('settings.upgrade-warning.body-texts.1', { newPackage: newPackageText }) }}
      </p>
    </div>

    <div class="d-flex flex-column align-center w-full">
      <ul>
        <li
          v-for="(feature, index) in features"
          :key="index"
        >
          {{ $t(feature) }}
        </li>
      </ul>
      <v-alert
        type="info"
        class="mt-4"
        variant="outlined"
      >
        <b>{{ $t('settings.upgrade-warning.body-texts.2') }}</b>
        {{ $t('settings.upgrade-warning.body-texts.3') }}
      </v-alert>
    </div>

    <div
      class="d-flex justify-space-between mb-2 mt-4 w-full"
      :class="{ 'flex-column': $vuetify.display.smAndDown }"
    >
      <v-btn
        :class="{ 'w-full mb-4': $vuetify.display.smAndDown, 'mr-4': $vuetify.display.mdAndUp }"
        @click="cancel"
        variant="outlined"
      >
        {{ $t('labels.cancel') }}
      </v-btn>
      <v-btn
        color="primary"
        :class="{ 'w-full': $vuetify.display.smAndDown }"
        @click="submit"
        :loading="isLoading"
      >
        {{ $t('buttons.upgrade-warning.cta') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import { products } from '@/lib/product'
import { formatProductName } from '@/lib/productNaming.js'
import { ProductType } from '@/lib/productTypes'
import branding from '@/mixins/branding'

export default {
  mixins: [branding],
  props: {
    currentPackage: {
      type: String,
      default: '',
    },
    newPackage: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      products,
    }
  },
  computed: {
    newPackageText() {
      return formatProductName(this.newPackage)
    },
    features() {
      const basicFeatures = Object.values(this.products[this.platform])
        .find((product) => product.productName === ProductType.BASIC)
        .features.slice(1)
      const expertFeatures = Object.values(this.products[this.platform])
        .find((product) => product.productName === ProductType.EXPERT)
        .features.slice(1)

      if (this.currentPackage === ProductType.LIGHT && this.newPackage === ProductType.BASIC)
        return basicFeatures
      else if (this.currentPackage === ProductType.LIGHT && this.newPackage === ProductType.EXPERT)
        return [...basicFeatures, ...expertFeatures]
      else return expertFeatures
    },
    upgradeAt() {
      return new Date()
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    submit() {
      this.$emit('submit')
    },
  },
  emits: ['cancel', 'submit'],
}
</script>
